import Button from '../../components/form-control/Button';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import TextArea from '../../components/form-control/TextArea';
import { generateAgencyPayout } from '../../api/requests';
import { showToast } from '../../utils/miscFunctions';

export interface ISetCommission {
  rate: string;
  type: string;
  teamId: string;
}

const GenerateAgencyPayoutModal = ({onProceed,onClose,teamID}: {
  onProceed: () => void;
  onClose: () => void;
  teamID: string;
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const submitHandler = (values: any) => {
    setSubmitting(true);
    const reason = values.reason;

    generateAgencyPayout(teamID, reason)
      .then((response: any) => {
        showToast.success(response?.message ?? 'Payout generated successfully', );
        onProceed();
      })
      .catch((error: any) => {
        showToast.error(error?.description ?? error.message);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="bg-white rounded-xl">
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            reason: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            reason: Yup.string().required('Commission rate is required.')
          })}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <TextArea
                  name="reason"
                  value={values.reason}
                  onChange={handleChange}
                  onBlur={handleChange}
                  label="Reason for generating payout"
                  placeholder="Give reason"
                  required
                  error={touched.reason ? errors.reason : undefined}
                  helperText={touched?.reason ? errors.reason : undefined}
                  classes="rounded"
                />
              </div>

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
              fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default GenerateAgencyPayoutModal;
